import * as $ from "jquery";
import 'intersection-observer/intersection-observer.js';
import {delineate} from "../lib/delineate";
import * as balanceText from "balance-text";
import {throttle} from "throttle-debounce";
import "../lib/objectFitPolyfill.min.js";
import "../lib/date-input-polyfill.dist.js";
import "es6-object-assign/dist/object-assign-auto.js";
import * as Stickyfill from "stickyfilljs/dist/stickyfill.min.js";
import * as Modernizr from "../lib/modernizr-3.5.0.min.js";
import {RegionHelper} from "./angular-modules/common/helpers/region.helper";
import TranslationsService from '../PFF/services/translationsService';

// Global sub-modules
import * as Nav from "./modules/nav";
import * as Pulldowns from "./modules/pulldowns";
import * as Search from "./modules/quickSearch";
import * as EmailSignup from "./modules/emailSignup";
import * as ScrollEffects from "./modules/scrollEffects";
import * as FavoritesDisplay from "./modules/favoritesDisplay";
import * as ProBrowsingToggle from "./modules/proBrowsingToggle";
import * as BackToTop from "./modules/backToTop";
import * as SupportCategoryGrid from "./modules/supportCategoryGrid";
import * as ImageGrid from "./modules/imageGrid";

// Basic modules
import * as Alerts from "./modules/alerts";
import * as Modals from "./modules/modals";
import * as ProductBuyOptions from "./modules/productBuyOptions";
import * as Tabs from "./modules/tabs";
import * as Tooltips from "./modules/tooltips";
import * as FavoriteToggle from "./modules/favoriteToggle";
import "../lib/jquery.arrowCallout.js";

// CMS modules
import * as Accordion from "./modules/accordion";
import * as BackgroundRotator from "./modules/backgroundRotator";
import * as ContentAndMediaVideo from "./modules/contentAndMedia";
import * as FileInput from "./modules/fileInput";
import * as HeroImage from "./modules/heroImage";
import * as HeroRotator from "./modules/heroRotator";
import * as FinishSwitcher from "./modules/finishSwitcher";
import * as PfisterConfiguration from "./modules/pfisterConfiguration";
import * as ImageSwitcher from "./modules/imageSwitcher";
import * as SectionNav from "./modules/SectionNav";
import * as Stack from "./modules/stack";
import * as BubbleTooltip from "./modules/bubbleTooltip";

// WURFL (wurfl.io) is a device-detection library used for edge cases
// like detecting whether a device is a phone so tel: links can be wrapped
declare let WURFL:any;
declare let objectFitPolyfill:any;

namespace PFF.Main {
	function addModernizrTests() {
		Modernizr.addTest('coarsepointer', function () {
			return Modernizr.mq('(pointer: coarse)') && !Modernizr.mq('(any-pointer: fine)');
		});

		Modernizr.addTest('ie11', function () {
			if (window.navigator.userAgent.match(/Trident\/7\./)) {
				return true;
			} else {
				return false;
			}
		});

		Modernizr.addTest('mobilesafari', function() {
			return /iP(ad|hone|od).+Version\/[\d\.]+.*Safari/i.test(navigator.userAgent);
		});
	}

	function setupArrowCallouts() {
		$('.js-arrow-callout').arrowCallout();
	}

	function applyPolyfills() {

		if (Modernizr.ie11) {
			objectFitPolyfill();
			var elements = $('.js-section-nav');
			Stickyfill.add(elements);
		}
	}

	function delineateFooterSubnav() {
		new delineate('.js-footer-links');
	}

	function setupBubbleTooltips(){
		if(!$('.bubble-tooltip').length) {
			return;
		}

		BubbleTooltip.init();
	}

	function initBackToTop() {
		$('.js-top').click(function (e) {
			$('body,html').animate({
				scrollTop: 0
			}, 800);
			e.preventDefault();
			return false;
		});
	}

	function initSmoothScroll(){
		$('.js-smooth-scroll').click(function (e) {
			let href = $(this).attr('href');
			let $element = $(href);
			$('body,html').animate({
				scrollTop: $element.offset().top
			}, 800);
			e.preventDefault();
			return false;
		});
	}


	function initBalanceText() {
		balanceText(
		`.balance-text,
		.block-link__title,
		.video__title,
		.hero-image__title-text,
		.hero-image__kicker,
		.hero-feature__review-text,
		.category-list__card-title`,
			{ watch: true }
		);
	}

	function initPhoneLinks() {
		if (WURFL && WURFL.form_factor === "Smartphone") {
			$('[data-tel]').each(function() {
				$(this).wrap('<a href="tel:' + $(this).data('tel') + '" />');
			})
		}
	}

	function calculateScrollbarWidth() {
		var $el = $('<div style="width: 100%"></div>');
		$el.appendTo('body');
		var constrainedWidth = $el.width();

		$el.css('width', '100vw');
		var fullWidth = $el.width();
		var scrollbarWidth = Math.ceil(fullWidth - constrainedWidth);

		document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
		$el.remove();
	}

	var iframeResizeTimeout;

	function resizeIframe() {
		var iframe_id = "locatoriframe"; // replace with id of the iframe to dynamically resize
		var count = 0;
		var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
		var eventer = window[eventMethod];
		var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
		eventer(messageEvent, function (e) {
			if (typeof (e.data) === 'string' && e.data.indexOf("w2gi:iframeHeightUpdated") !== -1) {				
				var dimensions = e.data.split("//");
				autoResize(dimensions[1], dimensions[2]);
			}
			if (typeof (e.data) === 'string' && e.data.indexOf("w2gi:scrollPage") !== -1) {
				var offsets = document.getElementById(iframe_id).getBoundingClientRect();
				var values = e.data.split("//");
				var destination = values[1];
				var offset = values[2];
				window.scrollTo(0, destination + offsets.top);
			}
		}, false);

		function autoResize(newheight, newwidth) {
			// Resizing the iframe triggers the iframe to throw the iframeHeightUpdated event again, which causes
			// an infinite loop of iframe resizing. We will only resize the iframe if it's been at least 1 second since
			// the last resize event
			count = count + 1;
			if (window.matchMedia("(max-width: 767px)").matches) {
				var oldHeight = parseInt(document.getElementById(iframe_id).style.minHeight, 10) - 60;				
				console.log("Sizes" + ":" + oldHeight + "," + newheight);
				if (oldHeight != newheight) {				
					document.getElementById(iframe_id).style.minHeight = parseInt(newheight) + 60 + "px";
					document.getElementById(iframe_id).style.maxHeight = parseInt(newheight) + 60 + "px";
				}				
			}
			else {
				if (iframeResizeTimeout) { return; }
				document.getElementById(iframe_id).style.minHeight = parseInt(newheight) + 60 + "px";
				document.getElementById(iframe_id).style.maxHeight = parseInt(newheight) + 60 + "px";
				console.log("resized after checking timeout" + ":" + count);
				iframeResizeTimeout = setTimeout(function () {
					iframeResizeTimeout = null;
					console.log("went inside timeout" + ":" + count);
				}, 1000);
			}
		}
	}

	function quickSearchPath() {
		let quickSearchInput = $('.js-menu-quicksearch-input');
		let translationsService = TranslationsService.getInstance();
		let translationStrings = JSON.parse($("#navigationTranslations").html());
		translationsService.init(translationStrings);
		let searchPrefix = `${translationsService.translate('Forms.Search')}`;
		let modelNumberPlaceholder = `${translationsService.translate('ProductCard.Model')}`;
		let form = quickSearchInput.parents('.menu-quick-search');
		form.attr('action', `${RegionHelper.localizedUrl('')}/${searchPrefix}` );
		quickSearchInput.attr('placeholder', modelNumberPlaceholder);
		if($('.js-part-search-input').length) {
			$('.js-part-search-input').attr('placeholder', modelNumberPlaceholder);
		}
	}

	function setExternalLinks() {
		let baseHostName = window.location.hostname;

		$('a[href^=http]').each(function() {
			let $this = $(this);
			if ( this.hostname != baseHostName && !$(this).attr('target') && !$this.hasClass('js-allow-external') ) {
				$this.addClass('link--external');
				this.target = '_blank';
			}
		});

		$('a[href$=".pdf"], a[href$=".doc"], a[href$=".docx"]').attr('target', '_blank');
	}

	export function init(): void {
		calculateScrollbarWidth();
		addModernizrTests();
		applyPolyfills();
		delineateFooterSubnav();
		initBackToTop();
		initBalanceText();
		initPhoneLinks();
		setupArrowCallouts();
		resizeIframe();
		setExternalLinks();
		initSmoothScroll();
		setupBubbleTooltips();


		SupportCategoryGrid.init();
		// Init global sub-modules
		HeroImage.init();
		FinishSwitcher.init();
		PfisterConfiguration.init();
		EmailSignup.init();
		Nav.init();
		ScrollEffects.init();
		Search.init();
		Pulldowns.init();
		FavoritesDisplay.init();
		ProBrowsingToggle.init();
		BackToTop.init();
		ImageGrid.init();

		// Init basic modules
		Alerts.init();
		FileInput.init();
		Modals.init();
		ProductBuyOptions.init();
		Tabs.init();
		Tooltips.init();
		FavoriteToggle.init();

		// Init CMS modules
		Accordion.init();
		BackgroundRotator.init();
		ContentAndMediaVideo.init();
		HeroRotator.init();
		ImageSwitcher.init();
		SectionNav.init();
		Stack.init();
		quickSearchPath();
	}
}

$(document).ready(function () {
	PFF.Main.init();
});



// WEBPACK FOOTER //
// ./js/PFF/main.ts